import { useQuery } from "@tanstack/react-query";
import { FilterOption } from "../models";
import { apiInstance } from "../utils";

export type RequestFilterModelType =
  | "peticoes"
  | "sentencas"
  | "despachos"
  | "contratos"
  | "pareceres"
  | "denuncias"
  | "all";

export interface FetchFiltersResponse {
  success: boolean;
  filters: FilterOption[];
}

interface FetchFiltersParams {
  searchType: RequestFilterModelType;
}

export const getModelsTypeFilters = async ({
  searchType,
}: FetchFiltersParams): Promise<FetchFiltersResponse> => {
  console.log("Chamando: ", searchType);

  if (searchType === "all")
    return {
      filters: [],
      success: true,
    };
  const response = await apiInstance.get(`filtros/modelos/${searchType}`);
  return response.data;
};

export const useFiltersQuery = (params: FetchFiltersParams) =>
  useQuery({
    queryKey: ["filters", params?.searchType],
    queryFn: () => getModelsTypeFilters(params),
    enabled: true,
  });
